import { cn } from '@/lib/utils';
import type { VehicleListing } from '@/models/registry';
import { VehicleWholeSaleStatusBadge } from './vehicle-wholesale-status-badge';

export type VehicleWholeSaleStatusSelectorProps = {
  value: VehicleListing['transaction_type'];
  hideCopy?: boolean;
  buttonVariant?: 'outline' | 'ghost';
  className?: string;
};

export default function VehicleWholesaleStatusSelector({
  value,
  hideCopy = false,
  buttonVariant = 'ghost',
  className,
}: VehicleWholeSaleStatusSelectorProps) {
  return (
    <VehicleWholeSaleStatusBadge
      value={value}
      hideCopy={hideCopy}
      buttonVariant={buttonVariant}
      className={cn('pl-0 pointer-events-none', className)}
    />
  );
}
